export default [
	{
		type: "text",
		id: 1,
		items: [
			{
				id: 1,
				text: "Name of the exercise group leader:",
				type: "medium",
			},
		],
	},
	{
		type: "uni",
		id: 2,
		items: [
			{
				id: 2,
				text: "The exercise tasks were clearly understandable.",
			},
			{
				id: 3,
				text: "The requirements in the exercise were appropriate.",
			},
			{
				id: 4,
				text: "Exercise and lecture were well coordinated.",
			},
			{
				id: 5,
				text: "Questions were answered without any problems.",
			},
			{
				id: 6,
				text: "The exercise group leader was able to convey the content well.",
			},
			{
				id: 7,
				text: "The exercise group leader was well prepared for each exercise.",
			},
			{
				id: 8,
				text: "The exercise group leader is responsive enough to questions.",
			},
		],
	},
	{
		type: "text",
		id: 3,
		items: [
			{
				id: 9,
				text: "Remarks on the exercise group::",
			},
		],
	},
];
